import { gql } from "@apollo/client";

export default gql`
  query GovernmentActions($governmentSlug: String!) {
    government(slug: $governmentSlug) {
      _id
      actionsCount
      actions {
        ... on GroupRequest {
          _id
          group {
            _id
            slug
            name
            logo
          }
          inviter {
            ... on PendingUser {
              _id
              slug
              fullName
              avatar
            }
            ... on VendorUser {
              _id
              slug
              fullName
              avatar
            }
            ... on GovernmentUser {
              _id
              slug
              fullName
              avatar
            }
          }
          createdAt
        }

        ... on ProductStackRequest {
          _id
          product {
            _id
            slug
            name
            logo
          }
          vendor {
            _id
            slug
            name
            logo
          }
          inviter {
            ... on PendingUser {
              _id
              slug
              fullName
              avatar
            }
            ... on VendorUser {
              _id
              slug
              fullName
              avatar
            }
            ... on GovernmentUser {
              _id
              slug
              fullName
              avatar
            }
          }
          createdAt
        }

        ... on ProjectGovernmentVerificationRequest {
          _id
          status
          project {
            ... on GroupProject {
              _id
              slug
              title
              audience
              author {
                ... on PendingUser {
                  _id
                  slug
                  fullName
                  avatar
                }
                ... on VendorUser {
                  _id
                  slug
                  fullName
                  avatar
                }
                ... on GovernmentUser {
                  _id
                  slug
                  fullName
                  avatar
                }
              }
              group {
                _id
                slug
                name
                logo
              }
            }
            ... on VendorProject {
              _id
              slug
              title
              audience
              author {
                ... on PendingUser {
                  _id
                  slug
                  fullName
                  avatar
                }
                ... on VendorUser {
                  _id
                  slug
                  fullName
                  avatar
                }
                ... on GovernmentUser {
                  _id
                  slug
                  fullName
                  avatar
                }
              }
              vendor {
                _id
                slug
                name
                logo
              }
            }
          }

          createdAt
        }
      }
    }
  }
`;
